<template>
  <div class="topicApply">
    <!-- <div class="tophead">
      <i @click="goBack"></i>
      <span class="title">发布</span>
      <span class="pub-btn" @click="pub">提交</span>
    </div> -->
    <div class="content">
      <van-field
        v-model="content"
        rows="5"
        autosize
        type="textarea"
        maxlength="140"
        placeholder="可以分享这一刻的想法～"
        show-word-limit
      />
    </div>
    <div class="photos">
      <van-uploader
        :max-count="9"
        v-model="fileList"
        multiple
        :after-read="afterRead"
        @delete="deleteImage"
        accept="image/*"
      />
    </div>

    <div class="type" @click="typeShow = true">
      <span># {{ topicTitle }}</span>
    </div>

    <div class="tijiao" @click="pub">提交</div>

    <!-- <div class="topicTypeList" v-if="typeShow">
        <div class="tophead">
        <i @click="typeShow=false"></i>
        <span class="title">选择话题</span>
        <span></span>
        </div>
        <div class="list">
        <div class="list-item" v-for="item in topicList" :key="item.id" @click="onClickItem(item)">
                <img :src="item.image" alt="">
                <div class="item-cover">
                    <span class="item-title">{{item.title}}</span>
                    <span class="item-num">{{item.join_num}} 人参与</span>
                </div>
        </div>
        </div>
    </div> -->
  </div>
</template>

<script>
import { uploadTopicPhoto, getTopicList2, postTopic } from "@/request/api";
import {
  compress,
  base64ImgtoFile,
} from "../../../../../../util/compressImage";

export default {
  data() {
    return {
      typeShow: false,
      content: "",
      fileList: [],
      imgList: [],
      topicList: [], // 分类板块列表
      topicTitle: this.getQueryVariable("title"),
      topicId: this.getQueryVariable("id"),
      share: 1,
    };
  },
  methods: {
    //文件读取完回调函数
    afterRead(result) {
      // 判断单张还是多张图片
      if (result instanceof Array) {
        result.map((item) => {
          this.uploadImage(item);
        });
      } else {
        this.uploadImage(result);
      }
    },
    // 删除图片
    deleteImage(result) {
      this.imgList.splice(result.index, 1);
    },
    // 上传图片
    uploadImage(file) {
      const toast = this.$toast;
      toast.loading({
        duration: 0, // 持续展示 toast
        message: "上传中...",
      });
      // 压缩图片
      let reader = new FileReader();
      reader.readAsDataURL(file.file);
      reader.onload = (e) => {
        // 文件读取完成时触发
        let result = e.target.result; // base64格式图片地址
        var image = new Image();
        image.src = result; // 设置image的地址为base64的地址
        image.onload = () => {
          // 图片加载完成后才能进行压缩处理，从而转换为base64 进行赋值
          let width = image.width; // 图片宽度
          let height = image.height;
          let img64 = compress(image, width, height, 0.7);
          // 拿到文件名
          let fileName = file.name;
          // 2，在转为 file类型
          let file1 = base64ImgtoFile(img64, fileName);
          // console.log(file);
          let param = new FormData();
          param.append("img", file1);
          param.append("pic_name", "img");
          uploadTopicPhoto(param)
            .then((res) => {
              if (res.error_code === 0) {
                this.imgList.push(res.url);
              }
              toast.clear();
            })
            .catch((error) => {
              toast.clear();
              console.log(error);
            });
        };
      };
    },
    //图片大小超过2M提示
    // onOversize() {
    //   this.$toast("图片大小不能超过 2M");
    // },
    goBack() {
      this.$router.go(-1);
    },

    pub() {
      if (this.content === "") {
        this.$toast("内容不能为空！");
        return;
      }
      if (this.imgList.length === 0) {
        this.$toast("至少上传一张图片！");
        return;
      }
      let param = new FormData();
      param.append("content", this.content);
      param.append("topic_id", this.topicId);
      param.append("plate_id", 0);
      param.append("image", this.imgList.toString());
      param.append("sessionid", this.getQueryVariable("sessionid"));

      postTopic(param)
        .then((res) => {
          this.$toast(res.error_msg);
          if (res.error_code === 0) {
            setTimeout(() => {
              history.back();
            }, 1500);
          }
        })
        .catch((error) => {
          console.log(error);
        });

     
    },

    // 获取晒照分类板块儿
    initTopicList() {
      getTopicList2({
        page: 1,
        pcount: 1000,
      })
        .then((res) => {
          let { data, error_code } = res;
          if (error_code === 0) {
            this.topicList = data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    onClickItem(item) {
      this.selectTopic = item;
      this.typeShow = false;
    },

    getImgSize(base64url) {
      var str = base64url.replace("data:image/png;base64,", "");
      var equalIndex = str.indexOf("=");
      if (str.indexOf("=") > 0) {
        str = str.substring(0, equalIndex);
      }
      var strLength = str.length;
      var fileLength = parseInt(strLength - (strLength / 8) * 2);
      var size = "";
      size = (fileLength / 1024).toFixed(2);
      var sizeStr = size + "";
      var index = sizeStr.indexOf(".");
      var dou = sizeStr.substr(index + 1, 2);
      if (dou == "00") {
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
      }
      return size;
    },

    getQueryVariable(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
  },
  created() {
    // this.topicId = this.getQueryVariable('id');
    // this.topicTitle = this.getQueryVariable('title');
    this.initTopicList();
  },
};
</script>


<style lang="less" scoped>
.topicApply {
  padding: 1rem;
  background: #fff;
}
.tophead {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 3.75rem;
  i {
    width: 24px;
    height: 24px;
    background: url(../../../../../assets/img/icon_back.png) no-repeat;
    background-size: 100% 100%;
  }
  .title {
    font-size: 18px;
    font-weight: 500;
    color: rgba(34, 34, 34, 1);
  }
  .pub-btn {
    font-size: 16px;
    color: #158ce8;
  }
}

.photos {
  margin: 1.5rem 0;
}
.type {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f8f8f8;
  padding: 1rem 0;
}
.tijiao {
  width: 60%;
  height: 2.5rem;
  line-height: 2.5rem;
  background: #ff6385;
  color: #fff;
  margin: 2.25rem auto;
  border-radius: 1.25rem;
  text-align: center;
}
.topicTypeList {
  background: #fff;
  padding: 1rem;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .list-item {
      width: calc(50% - 12px);
      height: 7.25rem;
      margin: 3px 6px;
      border-radius: 5px;
      overflow: hidden;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .item-cover {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.65);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 0.75rem;
        .item-title {
          color: #fff;
          font-size: 1rem;
          width: 70%;
        }
        .item-num {
          color: #fff;
          font-size: 0.75rem;
        }
      }
    }
  }
}
</style>
